import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    // eslint-disable-next-line no-console
    console.error("cost route crashed:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="px-8 py-6 space-y-3">
          <h2 className="text-lg font-medium text-red-400">Render-Fehler</h2>
          <p className="text-sm text-kw-text-muted">
            Eine Route konnte nicht gerendert werden — vermutlich ein
            Schema-Mismatch zwischen API-Response und Frontend-Typ.
          </p>
          <pre className="bg-kw-bg-elevated rounded p-3 text-xs text-kw-text-primary overflow-auto">
            {this.state.error.message}
            {"\n\n"}
            {this.state.error.stack?.split("\n").slice(0, 8).join("\n")}
          </pre>
          <button
            onClick={() => this.setState({ error: null })}
            className="px-3 py-1 bg-kw-l3 text-white rounded text-sm"
          >
            Zurücksetzen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
